import { callApiToServer } from "../callApi";

export async function uploadNeedyFamily(authtoken, needyFamilyObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      fileName: needyFamilyObject.file,
    });

    let endUrl = "v1/auth/add-needy-family-excel";

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}

export async function uploadSingleNeedyFamily(authtoken, needyFamilyObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify(needyFamilyObject);

    let endUrl = "v1/auth/add-needy-family";

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
